<i18n
  src="@/locales/views/agro_exporter/certifications/providers/manage_providers.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName(`show_${provider_type}`)"
    :params="goBackParams()"
  ></go-back-link>

  <bread-crumbs :labels="[module_name, provider?.name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div v-if="load_data_general" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form"> Organismo de certificación </label>
              <div class="mt-1">
                <select-form
                  v-if="certifiers.length > 1"
                  :options="certifiers"
                  v-model="certifier.certifier_id"
                  :class="isInvalidSelect('certifier_id')"
                />
                <div class="content-data" v-else-if="certifiers.length == 1">
                  {{ certifiers[0].name }}
                </div>
              </div>
            </div>
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('code')]">
                Código
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="certifier.code"
                  :class="['input-text', isInvalid('code')]"
                />
              </div>
            </div>
          </div>
          <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('name')]">
                Encargado de certificaciones
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="manager.name"
                  :class="['input-text', isInvalid('name')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('mobile_number')]">
                Celular
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="manager.mobile_number"
                  :class="['input-text', isInvalid('mobile_number')]"
                />
              </div>
            </div>
            <div class="sm:col-span-3">
              <label :class="['label-form', isInvalidLabel('email')]">
                Correo
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model="manager.email"
                  :class="['input-text', isInvalid('email')]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowProvider()"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="submit()"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import OrganizationRequester from "@/views/agro_exporter/requesters/certifications/providers/manage_organization_certification.js";
import PackingHouseRequester from "@/views/agro_exporter/requesters/certifications/providers/manage_packing_house_certification.js";
import ProducerRequester from "@/views/agro_exporter/requesters/certifications/providers/manage_crop_field_certification.js";
import Requester from "@/views/agro_exporter/requesters/certifications/providers/manage_providers.js";

export default {
  name: "AECertificationsProvidersManageProvider",
  components: {},
  data() {
    return {
      load_data_general: false,
      proc_save_button: false,
      provider: {},
      certifiers: [],
      manager: {
        name: "",
        mobile_number: "",
        email: ""
      },
      certifier: {
        certifier_id: null,
        code: null
      }
    };
  },
  props: {
    agro_exporter_id: { required: true },
    provider_type: { type: String, required: true },
    provider_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  },
  computed: {},
  methods: {
    loadData: async function () {
      await this.fetchProvider();
      await this.fetchCertifiers();
      this.load_data_general = true;
    },
    fetchProvider: async function () {
      switch (this.provider_type) {
        case "organization":
          return await this.fetchOrganization();
        case "packing_house":
          return await this.fetchPackingHouse();
        case "producer":
          return await this.fetchProducer();
      }
    },

    async fetchOrganization() {
      let response = await OrganizationRequester.fetchOrganization(
        this.agro_exporter_id,
        this.provider_id
      );

      this.provider = response.data;
    },

    async fetchPackingHouse() {
      let response = await PackingHouseRequester.fetchPackingHouse(
        this.agro_exporter_id,
        this.provider_id
      );

      this.provider = response.data;
    },

    async fetchProducer() {
      let response = await ProducerRequester.fetchProducer(
        this.agro_exporter_id,
        this.provider_id
      );

      this.provider = response.data;
    },

    async fetchCertifiers() {
      let response = await Requester.fetchCertifiers(this.agro_exporter_id);

      this.certifiers = response.data;
      if (this.certifiers.length == 1)
        this.certifier.certifier_id = this.certifiers[0].id;
    },

    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.manage(
          this.agro_exporter_id,
          this.provider_type,
          this.provider_id,
          {
            manager: {
              name: this.manager.name,
              mobile_number: this.manager.mobile_number,
              email: this.manager.email
            },
            certifier: {
              certifier_id: this.certifier.certifier_id,
              code: this.certifier.code
            }
          }
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowProvider();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },

    goToShowProvider: function () {
      this.$router.push({
        name: this.routeName(`show_${this.provider_type}`),
        params: this.goBackParams()
      });
    },

    goBackParams: function () {
      let params = { agro_exporter_id: this.agro_exporter_id };
      params[`${this.provider_type}_id`] = this.provider_id;
      return params;
    }
  },

  watch: {
    provider: function () {
      this.manager.name = this.provider.manager?.name;
      this.manager.mobile_number = this.provider.manager?.mobile_number;
      this.manager.email = this.provider.manager?.email;
      this.certifier.certifier_id = this.provider.certifier?.id;
      this.certifier.code = this.provider.certifier_code;
    }
  }
};
</script>
